
export const getInitialAppState = () => {
    return {
        steps: getInitialSteps(),
        completed: [],
        curStep: 
        {
            name: 'portal-intro',
            caption: "Portal Introduction",
            completeWithNext: true
        },
        // {
        //     name: 'repay-option',
        //     caption: "Repayment Option *",
        //     completeWithNext: true
        // },
        // {
        //     name: 'payment-form',
        //     caption: "Payment Form *",
        //     completeWithNext: true
        // },
        // {
        //     name: 'payment-success',
        //     caption: "Payment Success",
        //     completeWithNext: false
        // },
        activeStep: 0,
        stepDirection: 'left',
        repaymentOption: {
            input: {},  //FOrm input
            data: {},   //API Response
            status: null,   //API Status: start, success, failed
        },
        payment: {
            input: {},  //FOrm input
            status: null,   //API Status: start, success, failed
        },
        leadTime: {
            leadTime: '16',
            leadTimeStatement: 'It can take up to 16 business days for service initialization',
            statementDisplay: true,
            minConnectionDate: '12/11/2022'
        },
        showNeedLogin: false,
        showConfirmPayment: false,
        splashWait: {
            show: null,
            desc: null,
            descDefault: 'Stay hydrated, grab a glass of water... We are doing some ground work to fetch a perfect plan for you!'
        },

        error: {},
        loading: false,
        loadingMsg: null
    };
}

export const getInitialSteps = () => {
    return [
        {
            name: 'portal-intro',
            caption: "Portal Introduction",
            completeWithNext: true
        },
        {
            name: 'repay-option',
            caption: "Repayment Option *",
            completeWithNext: true
        },
        {
            name: 'payment-form',
            caption: "Payment Form *",
            completeWithNext: true
        },
        {
            name: 'payment-success',
            caption: "Payment Success",
            completeWithNext: false
        }
    ];
}

export const toBoolean = (str) => {
    return str === 'yes' ? true : (str === 'no' ? false : null)
}

export const toYesNo = (value) => {
    return value === true ? 'yes' : (value === false ? 'no' : null)
}